import { FORM_LOCAL_STORAGE_KEY } from "../consts";
import { FormikValues } from "formik";
import { IFormFromLocalStorage } from "../types";
import { IStep3FormValues } from "../step3/useStep3Form/iStep3FormValues";
import { calculateProductMappings } from "../step3/productsList/productMapping";
import { Solutions, Subscriptions } from "../step3/productsList/productConstants";

export const getNextStep = (
  values: IStep3FormValues,
  employeesNumber: number | ""
) => {
  const {
    solutions: interestSolutions,
    subscriptions: interestSubscriptionProducts,
  } = calculateProductMappings(values.selectedProducts);

  if (employeesNumber && employeesNumber >= 1000) return 6;

  if (employeesNumber && employeesNumber < 20) return 3;

  const hasOnlyMultiOrHealthOrAwards =
    interestSolutions.every(
      (solution) =>
        solution === Solutions.MULTIBENEFITS_VR_VA ||
        solution === Solutions.MULTIBENEFITS_FLEXIBLE ||
        solution === Solutions.AWARDS
    ) &&
    interestSubscriptionProducts.every(
      (product) =>
        product === Subscriptions.HEALTH_NR1 ||
        product === Subscriptions.HEALTH_WELLHUB ||
        product === Subscriptions.HEALTH_OPTUM_CONEXA
    );

  const hasExpenses = interestSolutions.includes(Solutions.EXPENSES);
  const employeesLess499 =
    employeesNumber && employeesNumber >= 20 && employeesNumber <= 499;

  const goesToStep7Employee =
    employeesNumber && employeesNumber >= 20 && employeesNumber <= 999;

  const totalSelections =
    interestSolutions.length + interestSubscriptionProducts.length;

  const goesToStep7 =
    (goesToStep7Employee &&
      (hasOnlyMultiOrHealthOrAwards || totalSelections > 1)) ||
    (employeesLess499 && hasExpenses);

  if (goesToStep7) return 6;

  return 4;
};

export function getFormFromLocalStorage() {
  const rawFormFromLocalStorage =
    localStorage.getItem(FORM_LOCAL_STORAGE_KEY) || "{}";
  const formFromLocalStorage: IFormFromLocalStorage = JSON.parse(
    rawFormFromLocalStorage
  );

  return formFromLocalStorage;
}

export function saveFieldsOnLocalStorage(values: FormikValues) {
  const formFromLocalStorage = getFormFromLocalStorage();

  localStorage.setItem(
    FORM_LOCAL_STORAGE_KEY,
    JSON.stringify({ ...formFromLocalStorage, ...values })
  );
}
